(() => {
  if (customElements.get('rydvlt-launch')) return;
  customElements.define('rydvlt-launch', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.dialog.close();
      this.classList.add('launch-ready');
      this.read = key => { try { return localStorage.getItem(key); } catch (_) { return null; } };
      this.write = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };
      this.querySelector('[data-launch-open]').addEventListener('click', () => this.open(), options);
      this.querySelector('[data-launch-close]').addEventListener('click', () => this.dismiss(), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dismiss();
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) this.open();
      }, options);
      const success = this.querySelector('[data-launch-success]');
      if (success) this.write('rydvlt-launch-subscribed', '1');
      if (success || this.querySelector('[data-launch-error]')) { this.open(); return; }
      const dismissed = Number(this.read('rydvlt-launch-dismissed'));
      const hidden = dismissed && Date.now() - dismissed < Number(this.dataset.days) * 86400000;
      if (this.hasAttribute('data-editor') || this.hasAttribute('data-subscribed') || hidden || this.read('rydvlt-launch-subscribed')) return;
      this.attempts = 0;
      const attempt = () => {
        const busy = [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner')].some(el => el !== this.dialog && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        if (busy || document.hidden) {
          if (++this.attempts < 60) this.timer = setTimeout(attempt, 2000);
          return;
        }
        this.open();
      };
      this.timer = setTimeout(attempt, Number(this.dataset.delay) * 1000);
    }
    open() {
      clearTimeout(this.timer);
      if (!this.dialog.open) { this.previousFocus = document.activeElement; this.dialog.showModal(); }
    }
    dismiss() {
      this.write('rydvlt-launch-dismissed', String(Date.now()));
      this.dialog.close();
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      if (this.dialog?.open && this.dialog.close) this.dialog.close();
    }
  });
})();
